import logo from './404guru_logo.png';
import './App.css';

function App() {
  const currentYear = new Date().getFullYear();

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Oooops! Found 404 - but this time it's <span className="company-name">404 Guru</span> !
        </p>
      </header>
      <footer className="App-footer">
        <p>© {currentYear}, SIA 404 Guru | <a href="mailto:info@404guru.lv">info@404guru.lv</a></p>
      </footer>
    </div>
  );
}

export default App;
